import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';
// import bodyMarkup from '../markup2/mailingAdressees.js';
// import bodyMarkupList from '../markup2/mailingAdresseesList.js';
import toolsMarkup from '../markup/tools.js';


import b2bDocs from './b2b/docs.js';

// import filmApplicationsForConsider from '../lk/filmApplicationsForConsider.js';


const loaderSpinnerId = 'spinnerMailing';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const navMenuLineTabs = document.querySelector('#list-tab');

const mainTabPane = document.querySelector('#FestMain');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
// const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
// const mainTabPaneBTTypeDisplay = mainTabPane.querySelector('button[name=typeDataDisplay]');
// const mainTabPaneBTDeleteAll = mainTabPane.querySelector('button[name=removeEveryoneToGlobalChat]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=header]');




const body = document.querySelector('body');

// const menuBt =  document.querySelector('#MenuEveryoneMailing');




// mainTabPaneBTReload.addEventListener('click', () => {
//   getMainData();
// });

// mainTabPaneBody.addEventListener('click', function (evt) {
//   evt.preventDefault();

// });

// mainTabPane.querySelector('div[name=header]').addEventListener('click', function (evt) {
//   evt.preventDefault();
  
  // if(evt.shiftKey && evt.target.attributes.mID){
  //   askToRemove(evt.target.attributes.mID.nodeValue, 'Вы точно хотите исключить данную заявку из рассылки?');

  // } else if(evt.target.attributes.action) {
  //   let action = evt.target.attributes.action.nodeValue;

  //   if (action == 'remove')
  //       askToRemove(evt.target.attributes.mID.nodeValue, 'Вы точно хотите исключить данную заявку из рассылки?');

  // } else if(evt.target.attributes.mID)
  //   filmApplicationsForConsider.loadRequestFilmApplicationById(evt.target.attributes.mID.nodeValue, evt.target.attributes.numReq.nodeValue);
  

// });


function showThisView () {
  getMainData();
  let allTabs = document.querySelectorAll('.tab-pane');
  allTabs.forEach((item) => {
    item.classList.remove('active');
    item.classList.remove('show');
    if (!item.classList.contains('fade'))
      item.classList.add('fade');
  })

  document.querySelector('#FestMain').classList.remove('fade');
  document.querySelector('#FestMain').classList.add('active');
  document.querySelector('#FestMain').classList.add('show');
    // alert('showThisView');

}

function getMainData () {

  // bodyMarkup.cleanContainer();
  // bodyMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    url: `festival/${auth.currentFestival}/info`,
    data: '',
    callbackSuccess: (answer) => {
      if (answer.data) {
        mainTabPane.querySelector('b[name=licName]').innerHTML = answer.data.license.name;
        mainTabPane.querySelector('b[name=licExpirees]').innerHTML = tools.dateStringShort(answer.data.license.timeEnd);
        // окрыть tabs
        // спрятать все tabs
        let allHiddenTabs = ['menuTabFestAppBlockMenu','menuTabMediatekaBlockMenu','MenuSimpleCardFilms','MenuFilmApplicationForConsider','menuTabFestivalBlockMenu','globalVariables']

        allHiddenTabs.forEach((item) => {
          navMenuLineTabs.querySelector(`#${item}`).hidden = true;
        });

        let allAvailableTabs = answer.data.license.tabs;
        if (allAvailableTabs)
          JSON.parse(allAvailableTabs).forEach((item) => {
            console.log(item);
            if(navMenuLineTabs.querySelector(`#${item}`))
              navMenuLineTabs.querySelector(`#${item}`).hidden = false;
          });

        if(answer.data.localAdmin)
           navMenuLineTabs.querySelector('#globalVariables').hidden = false;

        // подсчетс сколько дней до начала фестиваля
        let curDate = new Date();
        let festDateStr = answer.data.schedule.tStart;
        let dateZero = new Date(festDateStr.substr(0, 4), festDateStr.substr(5, 2) - 1, festDateStr.substr(8, 2), parseInt(festDateStr.substr(11, 2), 10) , festDateStr.substr(14, 2), festDateStr.substr(17, 2));


        let dayBetweenDays = datediff(curDate, dateZero);
        if (dayBetweenDays > 0) {
          mainTabPane.querySelector('div[name=counterBeforeFest]').style.display = 'block';
          mainTabPane.querySelector('h3[name=countDayBefore]').innerHTML = dayBetweenDays + ' день/(ей)';
        } else
          mainTabPane.querySelector('div[name=counterBeforeFest]').style.display = 'none';
        
          mainTabPane.querySelector('h3[name=countRequestsOnFest]').innerHTML = `${answer.data.countFilmFestRequestApproved} / ${answer.data.countFilmFestRequest}`;

        if (tools.isNumeric(answer.data.adsCountView)) {
          mainTabPane.querySelector('div[name=blockAdsStatistic]').style.display = 'block';   
          mainTabPane.querySelector('h3[name=adsStatistic]').innerHTML = `${answer.data.adsCountView} / ${answer.data.adsCountClick}`;
        } else
          mainTabPane.querySelector('div[name=blockAdsStatistic]').style.display = 'none'; 

        if (tools.isNumeric(answer.data.countVotes)) {
          mainTabPane.querySelector('div[name=blockCountVotes]').style.display = 'block'; 
          mainTabPane.querySelector('h3[name=countVotes]').innerHTML = answer.data.countVotes;
        } else         
          mainTabPane.querySelector('div[name=blockCountVotes]').style.display = 'none'; 

        if (tools.isNumeric(answer.data.countUserTelegramBot)) {
          mainTabPane.querySelector('div[name=blockCountUserTelegramBot]').style.display = 'block'; 
          mainTabPane.querySelector('h3[name=countUserTelegramBot]').innerHTML = answer.data.countUserTelegramBot;
        } else         
          mainTabPane.querySelector('div[name=blockCountUserTelegramBot]').style.display = 'none'; 


        displayLocalComments(answer.data.localComments);
        readFestPermissons();
        // посчет сколько всего заявок


      };
    }
  };
};

function readFestPermissons() {

// if b2b than block other tabs;!!!!

  let globalMenu = document.querySelector('nav[name=globalMenu]');
  let allTabs = globalMenu.querySelectorAll('li');
   allTabs.forEach(element => {
        element.classList.remove('divDisabled');
      });


   let workWithB2b = false;


  let allPermissions = localStorage.getItem('permissionsOnFest');
  if (allPermissions) {
    
    allPermissions = JSON.parse(allPermissions);

  // console.log(allPermissions['workb2b']);
    // console.log(item);
    if(parseInt(allPermissions['workb2b']) == 1 )
      workWithB2b = true;
    

  }

  if (workWithB2b && parseInt(auth.data.operatorId, 10) > 1) {
    allTabs.forEach(element => {
        if(element.id)
          element.classList.add('divDisabled');
      });

    document.querySelector('#FestMain').classList.remove('active');
    document.querySelector('#FestMain').classList.remove('show');
    document.querySelector('#b2bDocsParntersCimena').classList.add('active');
    document.querySelector('#b2bDocsParntersCimena').classList.add('show');
    b2bDocs.reloadData();
  } else if( parseInt(auth.data.operatorId, 10) == 1){
    document.querySelector('#Menub2bDocsParntersCimena').classList.remove('divDisabled');
  } 
  else if(!workWithB2b){
    document.querySelector('#Menub2bDocsParntersCimena').classList.add('divDisabled');
  }
}

function displayLocalComments(arrComents) {
  if(arrComents){
    let htmlBody = '';

    const date = new Date();
    const curTimeZone = (date.getTimezoneOffset())/60 * -1;

    arrComents.reverse().forEach((item) => {
      htmlBody += `<div class="localNotes div-with-pattern">
                      <div class="header row m-0">
                        <b class="ml-1 mr-auto">${item.name}</b>
                        ${parseInt(auth.data.operatorId, 10) === parseInt(item.uid,10) ? `<i class="ml-auto mr-1 removeNote" action="removeNote" noteid="${item.id}">удалить</i>` :''}
                      </div>

                      <span>${tools.texWithLinks(item.lComments)}</span>
                      <i>${tools.dateStringFullAddTimeZone(item.lTime,curTimeZone)}</i>
                   </div>`;
    });
     mainTabPane.querySelector('div[name=lentaComments]').innerHTML = htmlBody;
  } else 
   mainTabPane.querySelector('div[name=lentaComments]').innerHTML = '';;
  // body...
}


mainTabPane.querySelector('button[name=addLocalComments]').addEventListener('click', function (evt) {
  let newComment = prompt('Новая заметка:');
  if (newComment) 
    xhr.request = {
      metod: 'POST',
      url: `festival/${auth.currentFestival}/localComments/`,
      data: `comment=${newComment}`,
      callbackSuccess: (answer) => {
        if (answer.data)
          displayLocalComments(answer.data.localComments); 
        }
      }
  
});


mainTabPane.querySelector('div[name=lentaComments]').addEventListener('click', function (evt) {
  // console.log(evt.target);
  if (evt.target.attributes.action && evt.target.attributes.action.nodeValue === 'removeNote') {
    if(confirm('Вы уверены, что хотите удалить данную заметку?')) 
        xhr.request = {
          metod: 'DELETE',
          url: `festival/${auth.currentFestival}/localComments/${evt.target.attributes.noteid.nodeValue}`,
          data: '',
          callbackSuccess: (answer) => {
            if (answer.data)
              displayLocalComments(answer.data.localComments);
            
          }
        };

  }


});

function datediff(first, second) {        
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
}

function reDisplayData() {

}


export default {

  start() {
    // menuBt.addEventListener('click', getMainData);
  },

  reloadData(){
    getMainData()
  },

  show() {
    showThisView();
  },

  stop() {
    bodyMarkup.cleanContainer();
  }
};
